import { Form, Level } from 'react-bulma-components';

import KeyTonicPicker from '../components/keytonic-picker';
import MarkdownTextarea from '../components/markdown-textarea';
import MarkdownTextareaAC from './markdown-textarea_ac';
import { PracticeContent } from '../components';
import React from 'react';
import Switch from '../components/switch';

const { Checkbox, Control, Field, Input, Label } = Form;

const ExerciseEditForm = ({ statePrefix, item, handleChange, skipInstrumentTransponation, id }) => {

  return (
    <>
    <Field>
      <Control>
      <Label>Key tonic:</Label>
      <Level><Level.Side align="left"><Level.Item>
        <KeyTonicPicker name={`${statePrefix}keytonic`} onChange={handleChange} value={item.keytonic} />
        {statePrefix!=="" && (
          <Switch name={`${statePrefix}allowUserKey`} label={'Allow user to change key'} checked={item.allowUserKey ?? false} onChange={handleChange} />
        )}
        </Level.Item></Level.Side></Level>
      </Control>
    </Field>
      <Field>
        <Label>Title</Label>
        <Control>
          <Input onChange={handleChange} name={`${statePrefix}title`} type="text" placeholder="The title of the practice" value={item.title ?? ""} />
        </Control>
      </Field>
      <Field>
        <Label>Decription</Label>
        <Control>
          <MarkdownTextareaAC name={`${statePrefix}description`} placeholder="Textarea" value={item.description ?? ""} onChange={handleChange}  pageSlug={id}/>
        </Control>
      </Field>
      <Label>Preview {item.keytonic}</Label>
      <PracticeContent title={item.title} description={item.description} allowUserKey={item.allowUserKey} keytonic={item.keytonic} skipInstrumentTransponation={skipInstrumentTransponation} isPreview={true} />
    </>
  )
}

export default ExerciseEditForm;